module.exports = __webpack_public_path__ + "media/src/images/icons/people-d8cb4e6ff70a5f259dd2cb52912c63ea.svg";